import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Universities from './pages/Universities';
import Programs from './pages/Programs';
import Services from './pages/Services';
import About from './pages/About';
import BusinessCooperation from './pages/BusinessCooperation';
import Partners from './pages/Partners';
import SuccessCases from './pages/SuccessCases';
import Contact from './pages/Contact';
import Sitemap from './pages/Sitemap';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import UniversityDetail from './pages/UniversityDetail';
import ProgramDetail from './pages/ProgramDetail';
import FacultyDetail from './pages/FacultyDetail';
import ApplicationQuery from './pages/ApplicationQuery';
import CaptchaTest from './pages/CaptchaTest';
import Dashboard from './pages/dashboard';
import Login from './pages/Login';
import theme from './theme/theme';
import { UserProvider } from './contexts/UserContext';
import './index.css';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "universities",
        element: <Universities />,
      },
      {
        path: "universities/:id",
        element: <UniversityDetail />,
      },
      {
        path: "universities/:universitySlug/faculties/:facultySlug",
        element: <FacultyDetail />,
      },
      {
        path: "programs",
        element: <Programs />,
      },
      {
        path: "programs/:id",
        element: <ProgramDetail />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "business-cooperation",
        element: <BusinessCooperation />,
      },
      {
        path: "partners",
        element: <Partners />,
      },
      {
        path: "success-cases",
        element: <SuccessCases />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "sitemap",
        element: <Sitemap />,
      },
      {
        path: "privacy",
        element: <Privacy />,
      },
      {
        path: "terms",
        element: <Terms />,
      },
      {
        path: "application-query",
        element: <ApplicationQuery />,
      },
      {
        path: "captcha-test",
        element: <CaptchaTest />,
      }
    ]
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <UserProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </UserProvider>
  // </React.StrictMode>
);
